// Function for buttons tag that will behave as links
const btnLinks = () => {

    // Select all buttons with the class 'link'
    const btnLinks_array = document.querySelectorAll('button.link');
    
    btnLinks_array.forEach(button => {
        // Adding add Event Listener
        button.addEventListener('click', function(e) {
            // Prevent default button behavior (like form submission)
            e.preventDefault(); 

            // Get the data-href value
            let linkTarget = e.target.getAttribute("data-href");
            // If has the class name "blank" means that will open a new tab
            let newTab = e.target.classList.contains('blank');
                
            /* To prevent a null target */
            if(linkTarget == null){
                let btnTarget = e.target.parentbutton;
             
                while(linkTarget == null){
                    linkTarget = btnTarget.getAttribute("data-href");
                    btnTarget = btnTarget.parentbutton;
                    newTab = btnTarget.classList.contains('blank');
                }
            }

            // Open in a new tab if the class 'blank' is present
            if(linkTarget){
                window.open(linkTarget, '_blank');
            }else{
                // Otherwise, redirect in the same tab
                window.location.href = linkTarget;
            }
            
        });

    });
}

export default btnLinks;
